import { ApplicationScreen } from "../top-level/screen/ApplicationScreen";
import { FallingLines } from "react-loader-spinner";
import { ContentBox } from "../structure/ContentBox";
import React from "react";

export function LoadingScreenComponent() {
    return (
        <ApplicationScreen withUser={false}>
            <LoadingBoxFillComponentInner />
        </ApplicationScreen>
    );
}

export function LoadingBoxComponent() {
    return (
        <ContentBox
            className={
                "mx-auto w-[180px] justify-center flex items-center h-fit space-x-16 flex-col"
            }
        >
            <FallingLines
                color="var(--color-primary-identity-blue)"
                width="100"
                visible={true}
            />

            <p className="text-n font-normal text-extra-placeholder-text">
                Henter...
            </p>
        </ContentBox>
    );
}

export function LoadingBoxFillComponent() {
    return (
        <div
            className={"min-h-[500px] flex-1 flex items-center justify-center"}
        >
            <LoadingBoxFillComponentInner />
        </div>
    );
}

export function LoadingBoxFillComponentInner() {
    return (
        <div className={"flex-1 flex items-center"}>
            <LoadingBoxComponent />
        </div>
    );
}

export function LoadingComponent() {
    return (
        <div className="flex flex-col justify-center items-center">
            <FallingLines
                color="var(--color-primary-identity-blue)"
                width="100"
                visible={true}
            />

            <p className="text-n font-normal text-extra-placeholder-text">
                Henter...
            </p>
        </div>
    );
}
